import { paginatedGql, toStandardResult } from "../util/graphql.js";

import gql from "graphql-tag";
import { useQuery } from "@apollo/react-hooks";

const trainingSessionSchema = `
  id
  kind
  training {
    reference
    name
  }
  company {
    code
    name
  }
  reference
  trainee {
    reference
    firstname
    lastname
  }
  amount
  status
  subscriptionDate
  period { from until }
`;

export function useTrainingSessionsStats() {
  const result = useQuery(
    gql`
      query GET_STATS {
        private {
          trainings {
            countByStatus: getTrainingSessionsCountByStatus {
              status
              count
            }
          }
        }
      }
    `,
    {
      fetchPolicy: "cache-and-network",
    },
  );
  return toStandardResult(result, "private.trainings", {
    transformData: (data) =>
      data && {
        archived: data.archived,
        ...(data.countByStatus || []).reduce(
          (stats, { status, count }) => ({ ...stats, [status]: count }),
          {},
        ),
      },
  });
}

export function useTrainingSessions(filter, pagination) {
  const result = useQuery(
    gql`
      query GET_TRAINING_SESSIONS($filter: TrainingSessionsFilterPrivateInput, $pagination: PaginationInput) {
        private {
          trainings {
            trainingSessions: findTrainingSessions(
              filter: $filter
              pagination: $pagination
            ) {
              ${paginatedGql(trainingSessionSchema)}
            }
          }
        }
      }
    `,
    {
      fetchPolicy: "cache-and-network",
      variables: {
        filter,
        pagination,
      },
    },
  );

  return toStandardResult(result, "private.trainings.trainingSessions");
}
